// extracted by mini-css-extract-plugin
export default {"container":"kp-z","heading":"lp-z","text":"mp-z","info":"np-z","link":"op-z","fullMaxWidth":"pp-z"};